define('BookingEngine/app-OtherCruises/settings',[],function () {
    return {
        container: '#othercruisePickYourCabin',
        deckplans: window.location.protocol + '//' + window.location.host + '/othercruisemodule/getdeckplan',
        gradesurl: window.location.protocol + '//' + window.location.host + '/othercruisemodule/selectcabingrade',
        cabinsurl: window.location.protocol + '//' + window.location.host + '/othercruisemodule/selectcabin',
        cruiseurl: window.location.protocol + '//' + window.location.host + '/othercruisemodule/activate'
    };
});
